import React, { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Select as AntdSelect } from "antd";
import * as Action from "../../../applicant/_redux/applicantActions";
import { useDispatch, useSelector } from "react-redux";
import API from "../../../../helpers/devApi";
import { swalError, swalSuccess } from "../../../../helpers/swal";
import { FaMinus } from "react-icons/fa";

const socialMediaOptions = [
  {
    platform: "Facebook",
    label: "Facebook",
    value: "Facebook",
    url: "",
  },
  {
    platform: "Linkedin",
    label: "Linkedin",
    value: "Linkedin",
    url: "",
  },
  {
    platform: "Youtube",
    label: "Youtube",
    value: "Youtube",
    url: "",
  },
  {
    platform: "X",
    label: "X",
    value: "X",
    url: "",
  },
  {
    platform: "Vimeo",
    label: "Vimeo",
    value: "Vimeo",
    url: "",
  },
  {
    platform: "Instagram",
    label: "Instagram",
    value: "Instagram",
    url: "",
  },
  {
    platform: "",
    label: "Other",
    value: "Other",
    url: "",
  },
];

const socialMediaDefined = {
  // Facebook: 'fa fa-facebook-official',
  // Linkedin: 'fa fa-linkedin',
  // Youtube: 'fa fa-youtube-play',
  // Twitter: 'fa fa-twitter',
  // Vimeo: 'fa fa-vimeo',
  // Instagram: 'fa fa-instagram'
  Facebook: "fab fa-facebook",
  Linkedin: "fab fa-linkedin",
  Youtube: "fab fa-youtube",
  Twitter: "fab fa-twitter",
  Vimeo: "fab fa-vimeo",
  Instagram: "fab fa-instagram",
  X: "fa-brands fa-x-twitter",
};

export default function SocialMedia({ id }) {
  const dispatch = useDispatch();
  const { social_medias } = useSelector(({ applicant }) => ({
    social_medias: applicant.social_medias,
  }));
  const [socialMedias, setSocialMedias] = useState({ social_medias: [] });
  const [loading, setLoading] = useState(false);

  const SocialMediaSchema = Yup.object().shape({
    social_medias: Yup.array().of(
      Yup.object().shape({
        platform: Yup.string().required("Social media is required"),
        url: Yup.string().required("Url is required"),
      })
    ),
  });

  const handleSubmitSocialMedia = async (values) => {
    setLoading(true);
    values.social_medias = values.social_medias?.map((item) => ({
      ...item,
      icon: socialMediaDefined[item.platform],
    }));
    values.applicant_id = parseInt(id);

    // const API_URL = 'http://localhost:6013/hrms_applicant_social_media';
    const API_URL = `hrms-applicant-portal/hrms_applicant_social_media`;
    await API.post(API_URL, values)
      .then((res) => {
        if (res?.data?.success) {
          swalSuccess("Data updated successfully!!");
          dispatch(Action.getApplicantsSocialMedia(id));
          if (values.social_medias?.length) {
            dispatch(
              Action.createProfileScore(
                {
                  name: ["Social Media"],
                  applicant_id: id,
                },
                () => {
                  dispatch(Action.getApplicantPersonalInfo(id));
                }
              )
            );
          } else {
            dispatch(
              Action.updateProfileScore(
                {
                  name: ["Social Media"],
                  applicant_id: id,
                },
                () => {
                  dispatch(Action.getApplicantPersonalInfo(id));
                }
              )
            );
          }
        } else {
          swalError(res?.data?.message, " ");
        }
      })
      .catch((error) => {
        swalError("someting went wrong");
      });

    setLoading(false);
  };

  useEffect(() => {
    setSocialMedias({ social_medias });
  }, [social_medias]);

  useEffect(() => {
    dispatch(Action.getApplicantsSocialMedia(id));
  }, []);

  return (
    <div className="card card_body_box mb-5">
      <Formik
        initialValues={socialMedias}
        validationSchema={SocialMediaSchema}
        onSubmit={(values) => handleSubmitSocialMedia(values)}
        enableReinitialize={true}
      >
        {({ errors, touched, setFieldValue, values }) => (
          <Form>
            <div className="row">
              <div className="col-md-12">
                <div className="card_header_with_edit_btn">
                  <div className="title">
                    <h2>Social Media Name</h2>
                  </div>
                </div>

                <hr />
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-md-6">
                <AntdSelect
                  placeholder="Add social media"
                  options={socialMediaOptions}
                  style={{ width: "100%" }}
                  onChange={(value, option) => {
                    setFieldValue("social_medias", [
                      ...values.social_medias,
                      option,
                    ]);
                  }}
                />
              </div>
            </div>
            {values?.social_medias?.length > 0 && (
              <div className="card mt-5">
                <div className="card-body">
                  {values.social_medias?.map((item, i) => {
                    return (
                      <div className="row mt-10 mx-5">
                        <div className="col-md-2 mb-3">
                          <label className="required">
                            <b>Social Media</b>
                          </label>
                          {socialMediaDefined[item.platform] ? (
                            <div>
                              {item.platform === "X" ? (
                                <div style={{ width: "50px", height: "50px" }}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    x="0px"
                                    y="0px"
                                    width="100%"
                                    height="100%"
                                    viewBox="0,0,256,256"
                                  >
                                    <g
                                      fill="#b5b5c3"
                                      fill-rule="nonzero"
                                      stroke="none"
                                      stroke-width="1"
                                      stroke-linecap="butt"
                                      stroke-linejoin="miter"
                                      stroke-miterlimit="10"
                                      stroke-dasharray=""
                                      stroke-dashoffset="0"
                                      font-family="none"
                                      font-weight="none"
                                      font-size="none"
                                      text-anchor="none"
                                    >
                                      <g transform="scale(5.12,5.12)">
                                        <path d="M5.91992,6l14.66211,21.375l-14.35156,16.625h3.17969l12.57617,-14.57812l10,14.57813h12.01367l-15.31836,-22.33008l13.51758,-15.66992h-3.16992l-11.75391,13.61719l-9.3418,-13.61719zM9.7168,8h7.16406l23.32227,34h-7.16406z"></path>
                                      </g>
                                    </g>
                                  </svg>
                                </div>
                              ) : (
                                <i
                                  style={{ fontSize: "3.5rem" }}
                                  className={`${
                                    socialMediaDefined[item.platform]
                                  }`}
                                ></i>
                              )}
                            </div>
                          ) : (
                            <Field
                              name="platform"
                              type="text"
                              value={item.platform}
                              className="form-control"
                              onChange={(event) => {
                                setFieldValue(
                                  `social_medias.${i}.platform`,
                                  event.target.value
                                );
                              }}
                            />
                          )}
                          {errors.social_medias &&
                          errors.social_medias.length > 0 &&
                          errors.social_medias[i]?.platform ? (
                            <div className="text-danger">
                              {errors.social_medias[i].platform}
                            </div>
                          ) : null}
                        </div>
                        <div className="col-md-4 mb-3">
                          <label className="required">
                            <b>URL</b>
                          </label>
                          <Field
                            name="url"
                            type="text"
                            className="form-control"
                            value={item.url}
                            onChange={(event) => {
                              setFieldValue(
                                `social_medias.${i}.url`,
                                event.target.value
                              );
                            }}
                          />
                          {errors.social_medias &&
                          errors.social_medias.length > 0 &&
                          errors.social_medias[i]?.url ? (
                            <div className="text-danger">
                              {errors.social_medias[i].url}
                            </div>
                          ) : null}
                        </div>
                        <div
                          className="col-md-2"
                          style={{
                            alignItems: "center",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <button
                            className="btn btn-danger mt-2"
                            type="button"
                            onClick={() => {
                              setFieldValue(
                                "social_medias",
                                values?.social_medias?.filter(
                                  (data, index) => index !== i
                                )
                              );
                            }}
                          >
                            <FaMinus /> Remove
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            <div className="edit_btn_group d-flex modal-footer m-0 p-0">
              {/* <button className='btn btn-default mr-4' >Cancel</button> */}
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                Save
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
